import { useFetch } from '@reveni-io/reveni-ui'

import commonServices from '@/common/services/services'

const useCarrierServices = ({ storeId, section, doInitialRequest = true }) => {
  const {
    data: carrierServices,
    loading: fetchingCarrierServices,
    fetchData: fetchCarrierServices,
  } = useFetch(() => commonServices.getCarrierServices({ storeId, section }), {
    doInitialRequest,
  })

  return {
    carrierServices: carrierServices || [],
    fetchingCarrierServices,
    fetchCarrierServices,
  }
}

export default useCarrierServices
